export const environment = {
  production: true,
  clientName: 'sps',
  apiUrl: '/back'
};